import React from "react";
import "../App.css";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  navbar: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "5em",
  },
  logo: {
    height: "3.5em",
    width: "auto",
  },
}));

export default function NavBar() {
  const classes = useStyles();

  return (
    <div className={classes.navbar}>
      <a href="/">
        <img className={classes.logo} src="/assets/c.png" alt="home" />
      </a>
    </div>
  );
}
